import React from 'react'

const SvgComponent = props => (
  <svg width={66} height={66} {...props}>
    <defs>
      <linearGradient
        x1="7.569%"
        y1="110.903%"
        x2="78.899%"
        y2="7.982%"
        id="git__prefix__a"
      >
        <stop stopColor="#FAC9E3" stopOpacity={0.4} offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="-12.039%"
        y1="1.214%"
        x2="155.653%"
        y2="90.79%"
        id="git__prefix__b"
      >
        <stop stopColor="#FBA4B5" offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <circle
        fill="url(#git__prefix__a)"
        opacity={0.166}
        cx={33}
        cy={33}
        r={33}
      />
      <path
        d="M21.93 0h1.178c.946.304 1.615.974 2.296 1.647 6.031 5.968 12.069 11.93 18.115 17.884.7.69 1.37 1.378 1.635 2.353v.931c-.274.973-.975 1.641-1.67 2.326-6.012 5.925-12.02 11.855-18.022 17.793-.693.687-1.37 1.378-2.355 1.648h-.943c-.947-.25-1.628-.87-2.288-1.546-.855-.88-1.755-1.719-2.63-2.581C12.054 35.329 6.866 30.2 1.668 25.08.986 24.41.308 23.75 0 22.815v-1.164c.303-.965 1.035-1.611 1.727-2.293 4.088-4.029 8.17-8.063 12.253-12.096.12-.118.253-.224.405-.36 1.652 1.63 3.28 3.226 4.888 4.845.105.106.09.387.047.567-.387 1.594.198 3.04 1.638 3.885.307.18.377.38.376.696-.007 3.743-.01 7.487.002 11.23.001.352-.104.547-.417.732-1.4.825-2.006 2.327-1.594 3.845.385 1.421 1.707 2.459 3.184 2.5 1.628.044 2.97-.869 3.465-2.36.482-1.452-.045-2.993-1.367-3.874-.306-.204-.394-.419-.393-.761.01-3.666.006-7.332.008-10.998 0-.14.028-.282.056-.526 1.433 1.419 2.78 2.773 4.157 4.098.302.291.385.531.276.947-.586 2.213 1.378 4.472 3.634 4.217 2.081-.236 3.467-1.997 3.153-4.01-.292-1.881-2.146-3.106-4.15-2.775-.224.037-.554-.047-.712-.2a253.55 253.55 0 0 1-4.377-4.318c-.14-.142-.221-.437-.186-.636.455-2.561-1.553-4.552-4.164-4.128-.202.033-.499-.052-.643-.192-1.557-1.506-3.093-3.035-4.634-4.558-.078-.077-.137-.173-.223-.284 1.082-1.062 2.147-2.095 3.2-3.14C20.295 1.02 20.952.3 21.929 0z"
        transform="translate(10 11)"
        fill="url(#git__prefix__b)"
      />
    </g>
  </svg>
)

export default SvgComponent
